<template>
  <dv-border-box-7>

    <div id="leftLevel">
      <div class="bg-color-black" style="height: 100%;">
        <div class="d-flex pt-2 pl-2" style="height:30px;">
          <div style="font-size:16px;color:#5cd9e8;float:left;padding:2px">
            最新成交项目

            <dv-decoration-1 style="width:1.25rem;height:.15rem; position:relative;top:-.0375rem;" />
          </div>
          <!-- <div style="float:right"><i class="el-icon-more-outline" style="font-size:20px;color:#5cd9e8;"></i>
          </div> -->
        </div>

        <div style="width:100%;height:88%">
          <dv-scroll-board :config="config" style="width:100%;height:100%" />
        </div>


      </div>
    </div>
  </dv-border-box-7>

</template>

<script>
  import * as echarts from "echarts";

  import axios from 'axios'
  export default {
    name: "lef",
    watch: {
      areaData(val) {
        this.areaDataObj = val;
      }
    },
    data() {
      return {
        selectType: "", //类别查询
        selectAreaNum: "", //面积查询
        itemNum: "", //项目编号
        itemName: "", //项目名称
        selectState: 0,
        chartData: [],
        unitCode: localStorage.getItem("unitCode"),
        config: {
          headerHeight: "30",
          header: ['项目名称', '成交价', '成交日期'],
          data: []
        }



      }
    },
    mounted() {
      this.getData();


    },
    methods: {
      getData() {
        this.config.data = [];
        this.$http.get("/web/announcement?pageNum=1&pageSize=20&unitCode=" + this.unitCode).then((
          res) => {
          console.log(res.data.data.list)
          var returnData = res.data.data.list;
          var arrData = [];
          for (var i = 0; i < returnData.length; i++) {
            // if( returnData[i].allMoney!=null){
            var oneArr = [returnData[i].name + "",returnData[i].publishTime.substr(0,10) + ""];
              arrData.push(oneArr);
          //    }
          }

          this.config = {
            data: arrData,
            header: ['项目名称', '成交时间'],
            columnWidth:[450,100],
            headerBGC: "#02424E",
            rowNum:9,

          };

          console.log(this.config.data)
        });
      },

     

    },
    
  }
</script>

<style lang="scss">
  .dv-scroll-board .header {
    width: 100% !important;
  }

  #leftLevel {
    padding: 0.2rem;
    height: 100%;
    min-width: 3.75rem;
    border-radius: 0.0625rem;

    .bg-color-black {
      height: 98%;
      border-radius: 0.125rem;
    }

    .text {
      color: #c3cbde;
    }

    #parent::-webkit-scrollbar {
      display: none;
      /* Chrome Safari */
    }

    #parent {
      scrollbar-width: none;
      /* firefox */
      -ms-overflow-style: none;
      /* IE 10+ */
      overflow-x: hidden;
      overflow-y: auto;
    }
  }
</style>
